import $ from 'jquery';
import clipTmpl from './hbs/clip.hbs';
import castingTmpl from './hbs/casting.hbs';
const $castingTmpl = $.templates(castingTmpl);
import { callApi, clipPlayer } from './util';

const $clipTmpl = $.templates(clipTmpl);
const docId = C.TVP.data.docId;

function videoClip($ctx) {
  const $wrapClip = $ctx.find('.clipList');
  const $listClip = $wrapClip.find('.list_video');
  openClip($listClip, 3);
}

function openClip(clipList, std) {
  clipList.each(function () {
    const $list = $(this).children('li');
    const len = $list.length;
    $list.on('click', '.wrap_thumb', function () {
      $list.parent().find('.video_player').remove();
      const $this = $(this);
      const idx = $this.parent().index() + 1;

      const $clipTit = $this.siblings('.f_link');
      const $clipDate = $this.siblings('.f_date');
      const clipId = $this.data('id');
      const playCount = $this.data('count');
      const regDate = $clipDate.text();
      const clipLink = $clipTit.attr('href');
      const clipTitText = $clipTit.text();
      const u = Math.ceil(idx / std);
      const parent = $this.parents('.tab_cont').attr('id');
      const clipData = {
        regDate: regDate,
        playCount: comma(playCount),
        tit: clipTitText,
        link: decodeURIComponent(clipLink),
        type: 'list',
        parent: parent + 'Player',
        docId:docId
      };
      const htmlOutput = $clipTmpl.render(clipData);

      $list.filter('.on').removeClass('on');
      $this.parent().addClass('on');

      (u * std) >= 0 && (u * std) < len ? $list.eq(u * std).before(htmlOutput) : $list.parent().append(htmlOutput);

      clipPlayer(clipData.parent, clipId);

      $list.find('.btn_close').on('click', function () {
        $(this).parent().removeClass('on');
        $list.parent().find('.video_player').remove();
      });

    });
  });
}


function comma(num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}


function videoCol($ctx) {
  const $colList = $ctx.find('.col_size3');
  const $videoCol = $colList.find('.video_col');
  const $player = $colList.children('li');

  $videoCol.on('click', 'div[class="wrap_thumb"]', function () {
    const $this = $(this);
    const $clipInfo = $this.siblings('.wrap_cont');
    const $clipTit = $clipInfo.find('.txt_subject');
    const clipId = $this.data('id');
    const playCount = $this.data('count');
    const titTxt = $clipTit.text();
    const clipLink = $this.data('link');
    const regDate = $clipInfo.find('.txt_date').text();
    const parent = $this.parents('.tab_cont').attr('id');
    const clipData = {
      regDate: regDate,
      playCount: comma(playCount),
      tit: titTxt,
      link: decodeURIComponent(clipLink),
      type: 'videoColl',
      parent: parent + 'player',
      docId:docId
    };
    const htmlOutput = $clipTmpl.render(clipData);

    if ($this.parent().hasClass('on')) {
      $this.parent().removeClass('on');
      $colList.find('.video_player').remove();
    } else {
      $videoCol.removeClass('on');
      $this.parent().addClass('on');
      $colList.find('.video_player').remove();
      $player.last().after(htmlOutput);
      clipPlayer(clipData.parent, clipId);
    }
  });
}


function beforeClip($ctx) {
  const $colList = $ctx.find('.clear');
  const $list = $colList.find('li');
  const $charName = $list.find('.f_link , .link_item');
  $list.on('click', function () {
    const $this = $(this);
    if ($this.parent().hasClass('video_col')) {
      const $clipTit = $this.find('.link_item');
      const $wrapThumb = $this.find('.wrap_thumb');
      const clipId = $wrapThumb.data('id');
      const playCount = $wrapThumb.data('count');
      const regDate = $wrapThumb.data('date').toString();
      const titTxt = $clipTit.text();
      const clipLink = $clipTit.attr('href');
      const parent = $this.parents('.tab_cont').attr('id');
      const clipData = {
        regDate: $.format.dateformat(regDate, 'yyyy.MM.dd'),
        playCount: comma(playCount),
        tit: titTxt,
        link: decodeURIComponent(clipLink),
        type: 'before',
        parent: parent + 'player',
        docId:docId
      };
      const htmlOutput = $clipTmpl.render(clipData);
      if ($this.hasClass('on')) {
        $list.removeClass('on');
        $colList.find('.video_player').remove();
        $colList.removeClass('video_open');
      } else {
        $list.removeClass('on');
        $colList.find('.info_appear').remove();
        $this.addClass('on');
        $this.after(htmlOutput);
        clipPlayer(clipData.parent, clipId);
        $colList.removeClass('casting_open');
        $colList.addClass('video_open');
      }

    } else {
      const charId = $this.find('.wrap_thumb').data('id');
      if (charId) {
        const params = {
          cnucc: '',
          w: 'iron',
          m: 'tv_character',
          q: charId,
          key: charId,
          viewtype: 'json'
        };
        const dataUrl = SF.getQsUrl(params, 1);
        callApi(dataUrl).done((response) => {
          try {
            const castingData = response.RESULT.IRON_TV_CHARACTER;
            castingFunc($colList, $list, $this, castingData);
          } catch (e) {
            console.log(e);
          }
        });
      } else {
        return;
      }
      paging();
      const $btnClose = $ctx.find('.ico_close_l');
      $btnClose.on('click', function () {
        $this.parent().find('.info_appear').remove();
        $this.removeClass('on');
        $colList.removeClass('casting_open');
      });
    }
  });
  $charName.on('click', function (e) {
    e.stopPropagation();
  });
  function castingFunc(wrap, list, $this, data) {
    wrap.removeClass('video_open');
    wrap.addClass('casting_open');
    wrap.find('.video_player').remove();
    list.removeClass('on');
    $this.addClass('on');

    const htmlOutput = $castingTmpl.render(data, {
      sameListLength: function (length) {
        return Math.ceil(length);
      },
      replaceProf: function () {
        const birthday = data.homo.solarCalendar;
        const year = birthday.substr(0, 4);
        const month = birthday.substr(4, 2);
        const day = birthday.substr(6, 2);
        return { year, month, birthday: `${year}.${month}.${day}` };
      },
      sourceUrl: function () {
        const homepageUrl = data.character.homepage.length > 0 ? data.character.homepage[0].url : undefined;
        return data.character.sourcePcUrl || homepageUrl || data.character.channel.homepageUrl || '';
      },
      encodeUri: function (txt) {
        return encodeURIComponent(txt);
      },
      docId: function () {
        return C.TVP.data.docId;
      }
    });

    $ctx.find('.info_appear').remove();
    $this.parent().append(htmlOutput);

  }
  function paging() {
    const nav = $('.info_appear .paging_nav');
    const sameList = $('.same_character .info_actor');
    new SF.pager({
      navigation: nav,
      list: sameList,
      viewCount: 2,
      isInfinite: false
    });
  }
}


export { videoClip, videoCol, beforeClip };


/** WEBPACK FOOTER **
 ** ./src/TVP/clip.js
 **/